import React from 'react';
import { motion } from 'framer-motion';
import { formatMessageTime } from '../../../utils/dateUtils';

interface ChatMessageProps {
  text: string;
  sender: 'user' | 'bot';
  timestamp: Date;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ text, sender, timestamp }) => {
  const isBot = sender === 'bot';
  
  return (
    <div className={`flex ${isBot ? 'justify-start' : 'justify-end'}`}>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className={`max-w-[80%] rounded-xl p-3 ${
          isBot
            ? 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white'
            : 'bg-blue-600 text-white'
        }`}
      >
        <div className="text-sm whitespace-pre-wrap">
          {text.split('\n').map((line, index) => {
            // Gestion des titres
            if (line.startsWith('# ')) {
              return (
                <h2 key={index} className="text-lg font-bold mb-2">
                  {line.replace('# ', '')}
                </h2>
              );
            }
            // Gestion des sous-titres
            if (line.startsWith('## ')) {
              return (
                <h3 key={index} className="text-base font-semibold mb-1">
                  {line.replace('## ', '')}
                </h3>
              );
            }
            // Gestion des listes
            if (line.startsWith('• ')) {
              return (
                <div key={index} className="flex items-start space-x-2 mb-1">
                  <span>•</span>
                  <span>{line.replace('• ', '')}</span>
                </div>
              );
            }
            // Gestion du texte en gras
            if (line.includes('**')) {
              const parts = line.split('**');
              return (
                <p key={index} className="mb-1">
                  {parts.map((part, i) => (
                    i % 2 === 0 ? part : <strong key={i}>{part}</strong>
                  ))}
                </p>
              );
            }
            // Texte normal
            return line ? <p key={index} className="mb-1">{line}</p> : <br key={index} />;
          })}
        </div>
        <span className="text-xs opacity-70 mt-1 block">
          {formatMessageTime(timestamp)}
        </span>
      </motion.div>
    </div>
  );
};

export default ChatMessage;